module.exports = __webpack_public_path__ + "img/report_banner2.1ac7b2f2.png";